import React, { useEffect, useState } from "react";
import {Article} from "../../data/types";
import twFocusClass from "utils/twFocusClass";
import Card from "components/Card/Card";
import "../../styles/styles.css";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const totalParPage = 6;

const PagePropositions = () => {
    const [articles, setArticles] = useState([])
       useEffect(() => {
        const getArticles = async () => {
          try {
            const response = await axiosInstance.get("api/articles/Propositions");

            // 🔥 Tri décroissant par createdAt
            const sorted = response.data.sort(
              (a: any, b: any) =>
                new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            );

            setArticles(sorted);
          } catch (error) {
            console.log("erreur:" + error);
          }
        };

        getArticles();
      }, []);

   
  return (
    <div className="stretch  bgColor">
        <div className="container py-6 lg:py-8 ">
          {/* HEADER */}
          <h2 className="inline-block align-middle text-4xl font-semibold md:text-5xl ">
            Propositions&nbsp;
          </h2>
         
          <span className="block text-black">{articles.length} articles</span>
          {/* ====================== END HEADER ====================== */}
          <div className="mt-6 flex flex-col sm:items-center sm:justify-between sm:flex-row">
            <div className="block border-b w-full border-neutral-500 sm:hidden"></div>
            <div className="flex justify-end">
            </div>
          </div>
          {/* LOOP ITEMS */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8 md:gap-x-8 md:gap-y-10 mt-8 lg:mt-10">
            {
              articles.map((post:any) => (
              <Card key={post.id} post={post} />  
            ))
            }
          </div>
        </div>
    </div> 
  );  
};

export default PagePropositions;
